import apiClient from "./axios.config";

const ownerForgot = {
  forgotPassword: async (phoneNo) => {
    try {
      const response = await apiClient.post("/owner/forgot-password", {
        phoneNo,
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
};

export default ownerForgot;
